/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Number of occurrences (alternative to until)
 */
export type RecurrenceRequestCount = number | null;
